<template>
	<section id="publishers-intro" class="intro">
		<img
			src="/images/pages/publishers/intro-frame.jpg"
			alt="intro-bg"
			class="intro__bg"
			fetchpriority="high"
			loading="eager"
			decoding="sync" />
		<video
			id="video-intro"
			ref="introVideo"
			playsinline
			src="/videos/intro.mp4"
			data-src="/videos/intro.mp4"
			poster="/images/pages/publishers/intro-frame.jpg"
			loop
			muted
			autoplay
			@loadeddata="onIntroVideoLoaded"
			:class="['intro__video', { 'intro__video--ready': isVideoReady }]">
			<track kind="captions" srclang="en" label="English captions" src="/captions/empty.vtt" />
		</video>
		<div class="intro__container container">
			<div class="intro__content">
				<h2 class="intro__title heading h2">
					{{ $t('pages.publishers.sections.intro.title') }}
				</h2>
				<p class="intro__subtitle">
					{{ $t('pages.publishers.sections.intro.subtitle') }}
				</p>
				<button class="common-btn" type="button" @click="publisherModal.openModal">
					{{ $t('pages.publishers.sections.intro.button') }}
				</button>
			</div>
			<NuxtLink to="#publishers-howto" class="intro__scroll-btn">
				<span>{{ $t('basics.scrollDown') }}</span>
				<Icon name="local:arrow-anim" size="30" />
			</NuxtLink>
		</div>
		<div id="about-us"></div>
	</section>
</template>

<script setup lang="ts">
	const { $gsap: gsap } = useNuxtApp()

	const menuStore = useMenuStore()
	const publisherModal = usePublisherModal()
	const isVideoReady = ref(false)

	function introAnimation() {
		// gsap
		// 	.timeline({
		// 		scrollTrigger: {
		// 			trigger: '.intro',
		// 			start: 'top top',
		// 			// end: 'bottom+=200',
		// 			// start: 'top top',
		// 			// end: 'bottom top',
		// 			// end: 'bottom top',
		// 			scrub: true,
		// 			pin: true,
		// 			pinSpacing: false,
		// 		},
		// 	})
		// 	.to('.intro__video', {
		// 		yPercent: -20,
		//         // scale: 1.2,
		// 		ease: 'none',
		// 	})
		gsap
			.timeline({
				scrollTrigger: {
					trigger: '.intro',
					start: 'top top',
					scrub: true,
					pin: true,
					pinSpacing: false,
					onEnter: () => (menuStore.isScrolled = true),
					onLeaveBack: () => (menuStore.isScrolled = false),
				},
			})
			.to('.intro', {
				opacity: 0,
				yPercent: -40,
				// scale: 1.1
				// ease: 'none',
			})
		// .to('.intro__bg', {
		// 	yPercent: -10,
		// 	ease: 'none',
		// }, 0)
	}

	const introVideo = ref<HTMLVideoElement | null>(null)

	function onIntroVideoLoaded() {
		isVideoReady.value = true
	}

	onMounted(() => {
		introAnimation()
		if (introVideo.value?.readyState && introVideo.value.readyState >= 2) {
			isVideoReady.value = true
		}
	})

	useVideoReady(
		'video-intro',
		() => {
			if (introVideo.value) {
				introVideo.value.play().catch((e) => {
					console.warn('Autoplay failed:', e)
				})
			}
		},
		introVideo
	)
</script>

<style scoped lang="scss">
	.intro {
		position: relative;
		z-index: 0;
		display: flex;
		flex-direction: column;
		gap: 20px;

		// align-items: center;
		justify-content: center;
		width: 100%;
		min-height: 100svh;

		// background: url('@/assets/images/intro-bg.jpg') no-repeat center;
		// background-size: cover;
		padding: 50px 0;
		overflow: clip;
		color: var(--pure-white);
		background-color: var(--black);

		// background-color: #00000099;
		&__bg,
		&__video {
			position: absolute;
			top: 0;
			left: 0;
			z-index: 0;
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
		&__video {
			opacity: 0;
			transition: opacity 0.45s ease;
		}
		&__video--ready {
			opacity: 1;
		}
		&__content {
			position: relative;
			z-index: 1;
			display: flex;
			flex-direction: column;
			gap: 20px;
			justify-content: center;
			height: 100%;

			// max-width: 60%;
			font-family: Montserrat, sans-serif;
		}
		&__title,
		&__subtitle {
			max-width: 65%;

			// color: var(--primary);

			@media (width <= 767.98px) {
				max-width: 100%;
			}
		}
		&__title {
			text-transform: uppercase;
		}
		&__subtitle {
			font-size: 22px;

			// font-weight: bold;

			@media (width <= 767.98px) {
				font-size: 16px;
			}
		}
		&__scroll-btn {
			position: absolute;
			bottom: 16px;
			left: 50%;
			z-index: 1;
			display: flex;
			flex-direction: column;
			align-items: center;
			font-family: Montserrat, sans-serif;
			font-size: 12px;
			color: var(--white);
			text-transform: uppercase;
			transform: translateX(-50%);
		}

		// &__title {
		// 	font-size: 72px;
		// 	line-height: 1.2;
		// 	color: var(--primary);
		// 	text-transform: uppercase;
		// 	font-family: 'Montserrat', sans-serif;
		// }
		// &__subtitle {
		// 	font-size: 32px;
		// 	line-height: 1.2;
		// 	color: var(--primary);
		// 	text-transform: uppercase;
		// 	font-family: 'Montserrat', sans-serif;
		// }
	}
	#about-us {
		position: absolute;
		bottom: 0;

		// scroll-margin-top: 80px;
	}
</style>
